/* eslint-disable react/prop-types */
import { Box, Button, Typography } from "@mui/material";
import { Download, Publish } from "@mui/icons-material";
import {
	MRT_GlobalFilterTextField,
	MRT_ToggleFiltersButton,
	MRT_ToggleFullScreenButton,
	MRT_TableInstance,
} from "material-react-table";
import { Job } from "../../../api";
import PortalTooltip from "../../helpers/PortalTooltip";

/**
 * Props interface for ImportTableToolbar component
 */
export interface ImportTableToolbarProps {
	// Table instance
	table: MRT_TableInstance<Job>;

	// State
	jobs: Job[];

	// Callbacks
	hasValidationErrors: () => boolean;
	exportCSV: () => void;
	createJobs: () => Promise<void>;
}

/**
 * Toolbar component for ImportTable with global search, filters, and action buttons.
 *
 * Features:
 * - Global search field
 * - Filter toggle
 * - Fullscreen toggle
 * - CSV export button
 * - Create Jobs button (disabled when validation errors exist)
 * - Error message display when validation fails
 */
export const ImportTableToolbar: React.FC<ImportTableToolbarProps> = ({
	table,
	jobs,
	hasValidationErrors,
	exportCSV,
	createJobs,
}) => {
	return (
		<Box className="toolbar-container">
			<Box className="toolbar-left">
				{/* import MRT sub-components */}
				<MRT_GlobalFilterTextField table={table} />
				<MRT_ToggleFiltersButton table={table} />
			</Box>
			<Box className="toolbar-right">
				<Box className="toolbar-actions">
					{hasValidationErrors() && (
						<Typography color="error" className="error-message">
							Fill out all required data
						</Typography>
					)}
					<PortalTooltip title="Download table as a CSV for easier double-checking. This CSV is not used by Rogo.">
						<Button color="primary" variant="outlined" onClick={exportCSV} disabled={jobs.length === 0}>
							<Download className="icon-in-button" />
							CSV
						</Button>
					</PortalTooltip>
					<PortalTooltip title="Submit jobs to Rogo">
						<Button color="primary" variant="contained" onClick={createJobs} disabled={hasValidationErrors()}>
							<Publish className="icon-in-button" />
							Create Jobs
						</Button>
					</PortalTooltip>
					<MRT_ToggleFullScreenButton table={table} />
				</Box>
			</Box>
		</Box>
	);
};
